import Vue from "vue";
import { abilitiesPlugin } from "@casl/vue";
import { defineAbility } from "@casl/ability";
import { usePermissions } from "@/store/modules/auth";

// Abilities are loaded during login, but since we still need to pass them here, we create an empty set of rules
export const abilities = defineAbility(() => {});

Vue.use(abilitiesPlugin, abilities, {
    useGlobalProperties: true,
});

(async () => {
    const { refreshPermissions } = usePermissions();
    await refreshPermissions();
})();
